import React from 'react'

import { Typography } from 'components/common'

import s from './MaintenanceInfo.module.scss'
import maintenance from '../../../assets/images/maintenance.svg'

const getCurrentDate = () => {
  const currentDate = new Date()

  // Format the date components
  const month = String(currentDate.getMonth() + 1).padStart(2, '0') // Months are zero-indexed, so add 1
  const day = String(currentDate.getDate()).padStart(2, '0') // Pad single digits with leading zero
  const year = currentDate.getFullYear()

  // Combine components into desired format
  const formattedDate = `${month}/${day}/${year}`
  return formattedDate
}

const MaintenanceInfo = () => {
  const currentDateFormatted = getCurrentDate()

  return (
    <div className={s.contentWrapper}>
      <div className={s.textContainer}>
        <Typography variant="h2">
          <span className={s.spanColor}>Maintenance</span> Notice
        </Typography>
        <div className={s.paragraphContainer}>
          <Typography variant="body2">
            Coinavatar will undergo 24 hours of maintenance to implement some
            key updates and improvements. The platform will be temporarily
            unavailable during this time.
            <br />
            <br />
          </Typography>
          <Typography variant="body2">
            <span className={s.spanBold}>
              <span className={s.spanColor} style={{ fontSize: '20px' }}>
                &#x1F6E0;
              </span>{' '}
              Maintenance Details:
            </span>
            <br />• Start: October 31, 2025, at 11:00 AM UTC
            <br />• End: October 31, 2025, at 2:00 PM UTC
            <br />
            <br />
          </Typography>
          <Typography variant="body2">
            We appreciate your patience and understanding as we work to bring
            you an improved experience. Normal service will resume right after
            maintenance!
            <span className={s.spanColor} style={{ fontSize: '18px' }}>
              {String.fromCodePoint(0x1f64f)}
            </span>
          </Typography>
        </div>
      </div>

      <div className={s.imageContainer}>
        <img src={maintenance} alt="crane" />
      </div>
    </div>
  )
}

export default MaintenanceInfo
